module.exports = __webpack_public_path__ + "static/media/d-key.fc3eae24.svg";